// @ts-ignore
import { routes } from '@shared/api/routes';

export const getCommentListUrl = (guid: string) => routes.getCommentListUrl({ _guid_: guid });
export const getExcessCommentListUrl = (guid: string) =>
    routes.getExcessCommentListUrl({ _positionId_: guid });
export const getWorkCommentListUrl = (guid: string) => routes.getWorkCommentListUrl({ _id_: guid });

export const saveNewPositionCommentUrl = (guid: string) => routes.saveCommentUrl({ _guid_: guid });
export const saveNewPositionExcessCommentUrl = (guid: string) =>
    routes.saveExcessCommentUrl({ _excessId_: guid });
export const saveNewPositionExtraWorkCommentUrl = (guid: string) =>
    routes.saveExtraWorkCommentUrl({ _id_: guid });
export const deleteCommentUrl = ({ guid, commentId }: { guid: string; commentId: string }) =>
    routes.deleteCommentUrl({ _guid_: guid, _commentId_: commentId });
export const deleteExcessCommentListUrl = ({
    guid,
    commentId,
}: {
    guid: string;
    commentId: string;
}) =>
    routes.deleteExcessCommentListUrl({
        _positionId_: guid,
        _commentId_: commentId,
    });
export const deleteExtraWorkCommentUrl = ({
    guid,
    commentId,
}: {
    guid: string;
    commentId: string;
}) =>
    routes.deleteExtraWorkCommentUrl({
        _positionExtraWorkId_: guid,
        _commentId_: commentId,
    });
